import { ZoomToExtent } from "ol/control";
import { Extent } from "ol/extent";
import { Renderer } from "./Renderer";

// Extends the default OpenLayers "ZoomToExtent" control, which by default only 
// zooms to a fixed or predefined extent, to zoom instead to an extent that is calculated 
// at the time the button is clicked - in this case, an extent that includes all current
// tracks (ie all current track layers), plus a small margin for better aesthetics

// Some useful references: 
// 
//      https://openlayers.org/en/latest/apidoc/module-ol_control_Zoom-Zoom.html
//      A control with 2 buttons, one for zoom in and one for zoom out. This control is one of the default controls of a map. To style this control use css selectors .ol-zoom-in and .ol-zoom-out.
//
//      https://openlayers.org/en/latest/apidoc/module-ol_control_ZoomToExtent-ZoomToExtent.html
//      A button control which, when pressed, changes the map view to a specific extent. To style this control use the css selector .ol-zoom-extent.
//
//      https://openlayers.org/en/latest/examples/navigation-controls.html
//      Example of zoom and zoom-to-extent controls
//
//      https://gis.stackexchange.com/questions/326407/openlayers-5-zoom-view-to-features-in-a-layer
//      Zoom to features in a layer

export default class ZoomToAllTracks extends ZoomToExtent {

    mapRenderer: Renderer<any>

    constructor(renderer: Renderer<any>) {
        const zoomIcon = String.fromCodePoint(0xF0293); // icon mdi-fullscreen
        super({
            tipLabel: "Zoom to fit",
            label: zoomIcon
        });
        this.mapRenderer = renderer
    }

    protected handleZoomToExtent(): void {
        const ext = this.mapRenderer.allTracksExtent()
        if (ext) {
            this.extent = this.outABit (ext);
            super.handleZoomToExtent();
        }
    }

    // Adjust the extent to zoom out just a little more (by a %age of its width & height) for 
    // aesthetic reasons, so that the tracks do not go all the way out to the sides of the 
    // map viewport.
    //
    // Note that Extent == [minX, minY, maxX, maxY]

    outABit(extent: Extent): Extent {
        const pct = 0.05 // 0.05 == 5%
        const width = extent[2] - extent[0]
        const height = extent[3] - extent[1]
        const dx = (width * pct ) / 2
        const dy = (height * pct ) / 2
        return [extent[0]-dx, extent[1]-dy, extent[2]+dx, extent[3]+dy]
    }
}